import data from "../../.sourceflow/jobs.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getJobs = ({ url_slug = null, limit = null } = {}) => {
  const collection = new BaseCollection(data.jobs).map((i) => ({ ...i, href: `/jobs/${i.url_slug}` }));

  if (url_slug) {
    return collection.getItems().find((i) => i.url_slug === url_slug);
  }

  if (limit) {
    return collection.getItems().slice(0, limit);
  }

  return collection.getItems();
};
